import type { Node } from '@tiptap/core'
import Table from '@tiptap/extension-table'
import TableCell from '@tiptap/extension-table-cell'
import TableHeader from '@tiptap/extension-table-header'
import TableRow from '@tiptap/extension-table-row'

const classAttr = {
  default: null,
  parseHTML: (element: HTMLElement) => element.getAttribute('class'),
  renderHTML: (attributes: { class?: string | null }) => (attributes.class ? { class: attributes.class } : {}),
}

/** Keep the class on a table node so the printed agreement matches the edited HTML. */
const withClass = (node: Node) =>
  node.extend({
    addAttributes() {
      return {
        ...this.parent?.(),
        class: classAttr,
      }
    },
  })

export const agreementTableExtensions = [
  withClass(Table).configure({ resizable: false }),
  withClass(TableRow),
  withClass(TableHeader),
  withClass(TableCell),
]
